/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionField = function () {
    cleverapps.EventEmitter.call(this);

    this.map = Merge2MissionField.parseMap();
    this.width = this.map.width;
    this.height = this.map.height;
    this.visibleRows = this.map.visibleRows;
    this.offsetByUnit = this.map.offsetByUnit;
    this.visibleOffset = 0;

    this.units = [...Array(this.height)].map(() => Array(this.width).fill(undefined));
};

Merge2MissionField.prototype = Object.create(cleverapps.EventEmitter.prototype);
Merge2MissionField.prototype.constructor = Merge2MissionField;

Merge2MissionField.NEIGHBOURS = [{ dx: 0, dy: -1 }, { dx: 0, dy: 1 }, { dx: -1, dy: 0 }, { dx: 1, dy: 0 }];

Merge2MissionField.MOVE = {
    MERGED: "merged",
    FED: "fed",
    MOVED: "moved",
    REJECTED: "rejected"
};

Merge2MissionField.GROUNDED_PREFIX = "*";

Merge2MissionField.EMPTY_CELL = ".";

Merge2MissionField.EMPTY_SAVED = ".";

Merge2MissionField.FOG_SAVED = "~";

Merge2MissionField.OPENED_SAVED = "#";

Merge2MissionField.LEGACY_EMPTY_SAVED = "..";

Merge2MissionField.getMapConfig = function () {
    return bundles.merge2mission_config.jsons.merge2mission_map_json.getJson();
};

Merge2MissionField.parseCell = function (token) {
    const grounded = token[0] === Merge2MissionField.GROUNDED_PREFIX;
    const body = grounded ? token.slice(1) : token;

    if (body === Merge2MissionField.EMPTY_CELL) {
        return undefined;
    }

    const cell = Merge2MissionFamilies.parseId(body);
    if (grounded) {
        cell.data = { grounded: Merge2MissionGroundedComponent.STATE.FOG };
    }

    return cell;
};

Merge2MissionField.parseMap = function () {
    const config = Merge2MissionField.getMapConfig();
    const rows = config.rows;

    const height = rows.length;
    const width = rows[0].length;
    const units = [];

    rows.forEach((row, index) => {
        const y = height - 1 - index;

        row.forEach((token, x) => {
            const cell = Merge2MissionField.parseCell(token);
            if (cell) {
                units.push({
                    x, y, code: cell.code, stage: cell.stage, data: cell.data
                });
            }
        });
    });

    const unitsByIndex = {};
    units.forEach((unit) => {
        unitsByIndex[unit.y * width + unit.x] = unit;
    });

    return {
        width,
        height,
        visibleRows: config.visibleRows,
        offsetByUnit: config.offsetByUnit || {},
        units,
        unitsByIndex
    };
};

Merge2MissionField.prototype.getVisibleOffset = function () {
    return this.visibleOffset;
};

Merge2MissionField.prototype.isValid = function (x, y) {
    return x >= 0 && x < this.width && y >= 0 && y < this.height;
};

Merge2MissionField.prototype.isActive = function (x, y) {
    return this.isValid(x, y) && y >= this.visibleOffset && y < this.visibleOffset + this.visibleRows;
};

Merge2MissionField.prototype.getUnit = function (x, y) {
    return this.isValid(x, y) ? this.units[y][x] : undefined;
};

Merge2MissionField.prototype.isEmpty = function (x, y) {
    return this.isValid(x, y) && !this.units[y][x];
};

Merge2MissionField.prototype.contains = function (unit) {
    return this.getUnit(unit.x, unit.y) === unit;
};

Merge2MissionField.prototype.getNeighbours = function (x, y) {
    const field = this;

    return Merge2MissionField.NEIGHBOURS
        .map((offset) => ({ x: x + offset.dx, y: y + offset.dy }))
        .filter((point) => field.isActive(point.x, point.y));
};

Merge2MissionField.prototype.eachCell = function (callback) {
    for (let y = 0; y < this.height; y++) {
        for (let x = 0; x < this.width; x++) {
            callback(x, y);
        }
    }
};

Merge2MissionField.prototype.eachVisibleCell = function (callback) {
    for (let y = this.visibleOffset; y < this.visibleOffset + this.visibleRows; y++) {
        for (let x = 0; x < this.width; x++) {
            callback(x, y);
        }
    }
};

Merge2MissionField.prototype.iterate = function (callback) {
    this.eachCell((x, y) => {
        if (this.units[y][x]) {
            callback(this.units[y][x], x, y);
        }
    });
};

Merge2MissionField.prototype.iterateVisible = function (callback) {
    this.eachVisibleCell((x, y) => {
        if (this.units[y][x]) {
            callback(this.units[y][x], x, y);
        }
    });
};

Merge2MissionField.prototype.findFreeSlot = function (fromX, fromY) {
    const slots = [];

    this.eachVisibleCell((x, y) => {
        if (this.isEmpty(x, y)) {
            slots.push({ x, y, distance: Math.abs(x - fromX) + Math.abs(y - fromY) });
        }
    });

    slots.sort((a, b) => a.distance - b.distance || a.y - b.y || a.x - b.x);

    return slots[0];
};

Merge2MissionField.prototype.getQueueOrigin = function () {
    return { x: Math.floor(this.width / 2), y: this.visibleOffset };
};

Merge2MissionField.prototype.getOffsetFor = function (unit) {
    const byStage = this.offsetByUnit[unit.code] || {};
    const offset = byStage[unit.stage];
    return offset !== undefined && offset > this.visibleOffset ? offset : undefined;
};

Merge2MissionField.prototype.createUnit = function (code, stage, data) {
    return new Merge2MissionUnit(code, stage, data);
};

Merge2MissionField.prototype.placeUnit = function (x, y, unit) {
    this.units[y][x] = unit;
    unit.x = x;
    unit.y = y;

    return unit;
};

Merge2MissionField.prototype.takeUnit = function (x, y) {
    const unit = this.units[y][x];

    this.units[y][x] = undefined;
    unit.x = undefined;
    unit.y = undefined;

    return unit;
};

Merge2MissionField.prototype.revealGrounded = function () {
    let changed;

    do {
        changed = false;

        this.iterateVisible((unit) => {
            const grounded = unit.findComponent(Merge2MissionGroundedComponent);
            if (!grounded || !grounded.updateState(this)) {
                return;
            }

            changed = true;

            if (Merge2MissionFamilies.isGroundable(unit.code, unit.stage)) {
                this.trigger("unitRevealed", unit);
            } else {
                this.releaseUnit(unit);
            }
        });
    } while (changed);
};

Merge2MissionField.prototype.releaseUnit = function (unit) {
    const x = unit.x;
    const y = unit.y;

    this.takeUnit(x, y);

    const released = this.placeUnit(x, y, this.createUnit(unit.code, unit.stage));
    this.trigger("unitReleased", unit, released);
};

Merge2MissionField.prototype.commit = function () {
    this.revealGrounded();
    this.trigger("changed");
};

Merge2MissionField.prototype.addUnit = function (x, y, unit) {
    this.placeUnit(x, y, unit);
    this.trigger("unitAdded", unit);
    this.commit();

    return unit;
};

Merge2MissionField.prototype.removeUnit = function (x, y) {
    const unit = this.takeUnit(x, y);
    this.trigger("unitRemoved", unit, x, y);
    this.commit();

    return unit;
};

Merge2MissionField.prototype.moveUnit = function (unit, x, y) {
    const fromX = unit.x;
    const fromY = unit.y;

    this.takeUnit(fromX, fromY);
    this.placeUnit(x, y, unit);
    this.trigger("unitMoved", unit, fromX, fromY);
    this.commit();
};

Merge2MissionField.prototype.pushUnit = function (source, target) {
    const sourceX = source.x;
    const sourceY = source.y;
    const targetX = target.x;
    const targetY = target.y;

    this.takeUnit(sourceX, sourceY);
    this.takeUnit(targetX, targetY);
    this.placeUnit(targetX, targetY, source);

    const slot = this.findFreeSlot(targetX, targetY);
    if (!slot) {
        this.placeUnit(sourceX, sourceY, source);
        this.placeUnit(targetX, targetY, target);
        return false;
    }

    this.placeUnit(slot.x, slot.y, target);
    this.trigger("unitMoved", source, sourceX, sourceY);
    this.trigger("unitMoved", target, targetX, targetY);
    this.commit();

    return true;
};

Merge2MissionField.prototype.extractRows = function (from, to) {
    const units = [];

    for (let y = from; y < to; y++) {
        for (let x = 0; x < this.width; x++) {
            if (this.getUnit(x, y)) {
                units.push(this.takeUnit(x, y));
            }
        }
    }

    return units;
};

Merge2MissionField.prototype.setVisibleOffset = function (offset) {
    if (offset === this.visibleOffset) {
        return [];
    }

    const previous = this.visibleOffset;
    const units = this.extractRows(previous, offset);

    this.visibleOffset = offset;
    this.trigger("visibleRowsChanged", previous, units);
    this.commit();

    return units.map((unit) => ({ code: unit.code, stage: unit.stage, data: unit.save() }));
};

Merge2MissionField.prototype.spawn = function (code, stage, data, origin) {
    const slot = this.findFreeSlot(origin.x, origin.y);
    if (!slot) {
        return undefined;
    }

    const unit = this.placeUnit(slot.x, slot.y, this.createUnit(code, stage, data));
    this.trigger("unitAdded", unit);
    this.trigger("unitSpawned", unit, origin);
    this.commit();

    return unit;
};

Merge2MissionField.prototype.canMerge = function (source, target) {
    return source.isMovable() && Boolean(source.getMergeResult(target));
};

Merge2MissionField.prototype.canFeed = function (source, target) {
    const customer = target.findComponent(Merge2MissionCustomerComponent);

    return Boolean(customer) && target.isRevealed() && source.isMovable() && source.isMergeable() && customer.canFeed(source);
};

Merge2MissionField.prototype.canDropOn = function (source, target) {
    return this.canMerge(source, target) || this.canFeed(source, target);
};

Merge2MissionField.prototype.findMergePair = function () {
    const units = [];
    this.iterateVisible((unit) => units.push(unit));

    for (let i = 0; i < units.length; i++) {
        for (let j = i + 1; j < units.length; j++) {
            if (this.canDropOn(units[i], units[j])) {
                return [units[i], units[j]];
            }

            if (this.canDropOn(units[j], units[i])) {
                return [units[j], units[i]];
            }
        }
    }

    return undefined;
};

Merge2MissionField.prototype.mergeUnits = function (source, target) {
    const result = source.getMergeResult(target);
    const x = target.x;
    const y = target.y;

    this.takeUnit(source.x, source.y);
    this.takeUnit(x, y);

    const unit = this.placeUnit(x, y, this.createUnit(result.code, result.stage));
    this.trigger("unitsMerged", source, target, unit);
    this.trigger("unitAdded", unit);
    this.commit();

    return unit;
};

Merge2MissionField.prototype.feedCustomer = function (source, target) {
    const customer = target.findComponent(Merge2MissionCustomerComponent);

    const reward = customer.feed();
    this.removeUnit(source.x, source.y);
    this.trigger("customerFed", target, source);

    return { reward };
};

Merge2MissionField.prototype.tryMove = function (fromX, fromY, toX, toY) {
    const rejected = { move: Merge2MissionField.MOVE.REJECTED };

    if (!this.isActive(fromX, fromY) || !this.isActive(toX, toY) || (fromX === toX && fromY === toY)) {
        return rejected;
    }

    const source = this.getUnit(fromX, fromY);
    if (!source || !source.isMovable()) {
        return rejected;
    }

    const target = this.getUnit(toX, toY);
    if (target && this.canMerge(source, target)) {
        return { move: Merge2MissionField.MOVE.MERGED, unit: this.mergeUnits(source, target) };
    }

    if (target && this.canFeed(source, target)) {
        return { move: Merge2MissionField.MOVE.FED, ...this.feedCustomer(source, target) };
    }

    if (!target) {
        this.moveUnit(source, toX, toY);
        return { move: Merge2MissionField.MOVE.MOVED, unit: source };
    }

    if (!target.isMovable() || !this.pushUnit(source, target)) {
        return rejected;
    }

    return { move: Merge2MissionField.MOVE.MOVED, unit: source };
};

Merge2MissionField.prototype.mine = function (unit) {
    if (!this.contains(unit) || unit.isGrounded()) {
        return undefined;
    }

    const minable = unit.findMinable();
    if (!minable) {
        return undefined;
    }

    const result = minable.mine();

    if (minable.isDone()) {
        const x = unit.x;
        const y = unit.y;
        const becomes = minable.getBecomes();

        this.removeUnit(x, y);
        if (becomes) {
            this.addUnit(x, y, this.createUnit(becomes.code, becomes.stage));
        }
    }

    return result;
};

Merge2MissionField.prototype.canCollectReward = function (unit) {
    return this.contains(unit) && !unit.isGrounded() && unit.getRewardAmount() > 0;
};

Merge2MissionField.prototype.collectReward = function (unit) {
    if (!this.canCollectReward(unit)) {
        return undefined;
    }

    this.removeUnit(unit.x, unit.y);

    return unit.getReward();
};

Merge2MissionField.prototype.isActionable = function (unit, type) {
    return this.contains(unit) && !unit.isGrounded() && unit.getType() === type;
};

Merge2MissionField.prototype.transform = function (unit) {
    if (!this.isActionable(unit, Merge2MissionFamilies.TYPE.TRANSFORM)) {
        return undefined;
    }

    const x = unit.x;
    const y = unit.y;
    const target = unit.getStageConfig().transformsTo;

    this.takeUnit(x, y);

    const result = this.placeUnit(x, y, this.createUnit(target.code, target.stage));
    this.trigger("unitTransformed", unit, result);
    this.trigger("unitAdded", result);
    this.commit();

    return result;
};

Merge2MissionField.prototype.getInfo = function () {
    const cells = [];
    const data = {};

    this.eachVisibleCell((x, y) => {
        const unit = this.units[y][x];
        const grounded = unit && unit.findComponent(Merge2MissionGroundedComponent);

        if (!unit) {
            cells.push(Merge2MissionField.EMPTY_SAVED);
        } else if (grounded) {
            cells.push(grounded.isOpened() ? Merge2MissionField.OPENED_SAVED : Merge2MissionField.FOG_SAVED);
        } else {
            cells.push(Merge2MissionFamilies.encodeUnit(unit.code, unit.stage));
        }

        const unitData = unit && unit.save();
        if (unitData) {
            data[cells.length - 1] = unitData;
        }
    });

    return {
        cells: cells.join(""),
        offset: this.visibleOffset || undefined,
        data: Object.keys(data).length ? data : undefined
    };
};

Merge2MissionField.prototype.parseSaved = function (saved) {
    const data = saved.data || {};
    const units = [];

    let index = 0;
    let position = 0;

    while (position < saved.cells.length) {
        const symbol = saved.cells[position];
        const x = index % this.width;
        const y = this.visibleOffset + Math.floor(index / this.width);

        if (symbol === Merge2MissionField.EMPTY_SAVED) {
            position += 1;
        } else if (symbol === Merge2MissionField.FOG_SAVED || symbol === Merge2MissionField.OPENED_SAVED) {
            const mapUnit = this.map.unitsByIndex[y * this.width + x];
            const state = symbol === Merge2MissionField.OPENED_SAVED ? Merge2MissionGroundedComponent.STATE.GROUNDED : Merge2MissionGroundedComponent.STATE.FOG;

            units.push({
                x, y, code: mapUnit.code, stage: mapUnit.stage, data: { grounded: state, ...data[index] }
            });
            position += 1;
        } else {
            const unit = Merge2MissionFamilies.decodeUnit(saved.cells.substr(position, 2));

            units.push({
                x, y, code: unit.code, stage: unit.stage, data: data[index]
            });
            position += 2;
        }

        index++;
    }

    return units;
};

Merge2MissionField.prototype.isLegacySaved = function (saved) {
    return saved.cells.length === this.width * this.height * 2;
};

Merge2MissionField.prototype.migrateSaved = function (saved) {
    const offset = saved.offset || 0;
    const revealed = cleverapps.createSet(saved.revealed || []);
    const savedData = saved.data || {};
    const cells = [];
    const data = {};

    for (let windowIndex = 0; windowIndex < this.visibleRows * this.width; windowIndex++) {
        const index = offset * this.width + windowIndex;
        const encoded = saved.cells.substr(index * 2, 2);

        if (encoded === Merge2MissionField.LEGACY_EMPTY_SAVED) {
            cells.push(Merge2MissionField.EMPTY_SAVED);
        } else if (encoded[0] !== encoded[0].toLowerCase()) {
            cells.push(revealed[index] ? Merge2MissionField.OPENED_SAVED : Merge2MissionField.FOG_SAVED);
        } else {
            cells.push(encoded);
        }

        if (savedData[index]) {
            data[windowIndex] = savedData[index];
        }
    }

    return {
        cells: cells.join(""),
        offset: saved.offset,
        data: Object.keys(data).length ? data : undefined
    };
};

Merge2MissionField.prototype.load = function (saved) {
    const field = this;

    if (saved && this.isLegacySaved(saved)) {
        saved = this.migrateSaved(saved);
    }

    if (saved) {
        this.visibleOffset = saved.offset || 0;
    }

    const units = saved
        ? this.map.units.filter((item) => item.y >= field.visibleOffset + field.visibleRows).concat(this.parseSaved(saved))
        : this.map.units;

    units.filter((item) => field.isValid(item.x, item.y)).forEach((item) => {
        field.placeUnit(item.x, item.y, field.createUnit(item.code, item.stage, item.data));
    });

    this.revealGrounded();
};
